import AutoAnimateHook from "./auto-animate-hook";
import CalendlyHook from "./calendly-hook";
import DisableCopyHook from "./disable-copy-hook";
import DwollaHook from "./dwolla-hook";
import {
  BoxExplorerHook,
  BoxPickerHook,
  DealBoxExplorerHook,
  DealBoxPreviewHook,
  DealBoxUploaderHook,
  InvestmentOpportunityBoxExplorerHook,
} from "./box-hooks";
import OnScrollHook from "./on-scroll-hook";
import { DoughnutChartHook } from "./graph-hooks";
import LivePhone from "live_phone";
import MSTippyHook from "./ms-tippy-hook";
import ParallelMarketsHook from "./parallel-markets-hook";
import PersonaHook from "./persona-hook";
import PetalFrameworkHooks from "../../../deps/petal_framework/assets/js/hooks";
import RichTextEditorHook from "./rich-text-editor-hook";
import SegmentResetHook from "./segment-reset-hook";
import { SortableInputsForHook } from "./sortable-hooks";
import StateMultiselectHook from "./state-multiselect";
import StorylaneHook from "./storylane-hook";
import {
  TableOfContentsHook,
  AdminTableOfContentsHook,
  ArticleTableOfContentsHook,
  DealUpdatesTableOfContentsHook,
} from "./table-of-contents-hook";
import TrimContentHook from "./trim-content-hook";
import UserIdentifyHook from "./user-identify-hook";
import VegaLite from "./vegalite-hook";
import ValidateFaIconHook from "./validate-fa-icon-hook";
import NestedSelectHook from "./nested-select-hook";
import WistiaScriptHook from "./wistia-script-hook";

// Either add hooks here or create a new file for each

// These are imported individually to avoid importing TippyHook.
export default {
  ...PetalFrameworkHooks,
  AutoAnimateHook,
  BoxExplorerHook,
  BoxPickerHook,
  CalendlyHook,
  DealBoxExplorerHook,
  DealBoxPreviewHook,
  DealBoxUploaderHook,
  DisableCopyHook,
  DoughnutChartHook,
  DwollaHook,
  OnScrollHook,
  InvestmentOpportunityBoxExplorerHook,
  LivePhone,
  MSTippyHook,
  NestedSelectHook,
  ParallelMarketsHook,
  PersonaHook,
  RichTextEditorHook,
  SegmentResetHook,
  SortableInputsForHook,
  StateMultiselectHook,
  StorylaneHook,
  TableOfContentsHook,
  AdminTableOfContentsHook,
  ArticleTableOfContentsHook,
  DealUpdatesTableOfContentsHook,
  TrimContentHook,
  UserIdentifyHook,
  VegaLite,
  ValidateFaIconHook,
  WistiaScriptHook,
};
